import { PAYMENTSBUTTON } from '../actionTypes';
import CONSTANTS from '../constants';

const initialState = {
  content: [],
  paymentsButtonStatus: undefined,
  paymentsButtonError: undefined,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case PAYMENTSBUTTON.FETCH:
      return {
        ...state,
        paymentsButtonStatus: CONSTANTS.API_STATUS.STARTED,
      };
    case PAYMENTSBUTTON.SUCCESS:
      return {
        ...state,
        ...action.payload,
        paymentsButtonStatus: CONSTANTS.API_STATUS.SUCCEEDED,
      };
    case PAYMENTSBUTTON.FAILED:
      return {
        ...state,
        paymentsButtonError: action.payload,
        paymentsButtonStatus: CONSTANTS.API_STATUS.FAILED,
      };
    default:
      return state;
  }
};
